<template>
  <div class="backup-control-comp">
    <div class="header">
      <div class="header-title">
        <span>自动备份（{{list.length}}/{{max}}）</span>
        <el-tooltip
          effect="dark"
          placement="bottom"
        >
          <div
            slot="content"
            style="width:226px;height:109px;line-height:1.8;font-size:14px;padding-top: 6px;"
          >
            提示：
            <br />最多备份20份，超出将覆盖最早的数据；请根据操作习惯设置备份时间间隔
          </div>
          <span class="question">?</span>
        </el-tooltip>
      </div>
      <span
        class="close"
        @click="close"
      ></span>
    </div>
    <div class="content">
      <div
        class="item"
        v-for="(item, i) in list"
        :key="i"
      >
        <backupItem
          :item="item"
          :tag="novip && i > 0 ? '升级VIP可恢复' : ''"
          @clickTag="showVipDialog()"
          @preview="preview"
          @revert="revert"
        ></backupItem>
      </div>
    </div>
    <div class="footer">
      <div class="footer-title">自动备份时间间隔/分钟</div>
      <div class="footer-content">
        <intervalMenu
          :disabled="duringBackup"
          :num="intervalMinutes"
          @clickItem="setIntervalValue"
        ></intervalMenu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import backupItem from '@/components/versionControl/backupItem';
import intervalMenu from '@/components/versionControl/intervalMenu';

export default {
  components: {
    backupItem,
    intervalMenu
  },
  data () {
    return {
      intervalValue: 5,
      max: 20,
      list: []
    }
  },
  computed: {
    ...mapGetters([
      'WorksId',
      'UserMsg',
      'UserLevel',
      'UserLevelType',
      'cooperationDraftOwnerId',
      'IsPrivateDraft',
      'cooperationDraftId'
    ]),
    ...mapGetters({
      intervalMinutes: 'draftBackup/getIntervalMinutes',
      duringBackup: 'draftBackup/getDuringBackup',
      backupList: 'draftBackup/getList',
    }),
    novip () {
      return this.UserLevel === 0 && this.UserLevelType === 0
    }
  },
  watch: {
    backupList (val) {
      this.updateList_(val);
    }
  },
  async created () {
    this.updateList();
  },
  methods: {
    ...mapActions({
      fetchBackupList_p: 'draftBackup/fetchList',
      revertBackup_p: 'draftBackup/revertBackup',
      fetchBackupList_c: 'draftBackup/fetchList_c',
      revertBackup_c: 'draftBackup/revertBackup_c',
    }),
    async fetchBackupList (...args) {
      if (this.IsPrivateDraft) {
        return this.fetchBackupList_p(...args);
      } else {
        return this.fetchBackupList_c(...args);
      }
    },
    async revertBackup (...args) {
      if (this.IsPrivateDraft) {
        return this.revertBackup_p(...args);
      } else {
        return this.revertBackup_c(...args);
      }
    },
    close () {
      this.$store.commit('draftBackup/isShowUI', false);
    },
    showVipDialog () {
      this.$modal.show("vipDialog", {
        msg: "升级会员可恢复早期自动备份数据",
        target: "vipsolo",
        type: "solo",
        soloTip: '可还原最新自动备份'
      });
    },
    setIntervalValue ({ item, index } = {}) {
      this.intervalValue = +item.value;
      this.$store.commit('draftBackup/setIntervalMinutes', this.intervalValue);
    },
    async updateList () {
      let list = await this.fetchBackupList({ draftId: this.WorksId, cooperationDraftId: this.cooperationDraftId});
      this.updateList_(list);
    },
    updateList_ (list) {
      this.list = list.map(v => {
        let date = v.date;
        if (typeof date === 'number' && date < +new Date('1971-1-1')) {
          date *= 1000;
        }
        return {
          ...v,
          time: new Date(date)
        }
      });
    },
    async revert (item) {
      this.$modal.show("MessageDialog", {
        // title: "",
        content:
          "确定要还原到选中版本吗？还原之后将会覆盖你当前的项目数据。",
        btns: ['Ok', 'Cancel', 'Close'],
        resultHandler: type => {
          if (type === 'Ok') {
            this.confirmRevert(item);
          }
        }
      });
    },
    async confirmRevert (item) {
      this.$bus.once('saveWorks.completed', async () => {
        let success = await this.revertBackup({
          draftId: this.WorksId, cooperationDraftId: this.cooperationDraftId,
          versionId: item.id
        });
        success && window.location.reload();
      });
      this.$bus.emit("save", {});
    },
    preview (item) {
      let draftType = this.IsPrivateDraft ? 'draftversion' : 'coopbackup'
      let itemId = item.id;
      let link = document.createElement('a');
      link.href = window.location.origin + `/draftpreview/index.html?id=${itemId}&${draftType}=1`;
      link.target = "_blank";
      link.click();
    }
  }
}
</script>

<style lang="scss" scoped>
.backup-control-comp {
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  padding-left: 0;
  height: 100%;
  z-index: 1;
}
.header {
  padding-left: 12px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.header-title {
  display: flex;
}
.content {
  padding-left: 12px;
  overflow-x: visible;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: calc(100% + 36px);
  background: linear-gradient(white 30%, hsla(0, 0%, 100%, 0)),
    radial-gradient(at top, rgba(0, 0, 0, 0.2), transparent 70%);
  background-repeat: no-repeat;
  background-size: 100% 5px, 100% 5px;
  background-attachment: local, scroll;
}
.footer {
  padding-left: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  height: 50px;
  border-top: solid 1px #d4d4e7;
}
.footer-title {
}
.close {
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-image: url(../../../static/svg/materialPane/closePane.svg);
}
.question {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: #fff;
  background-color: #484262;
}
.item {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/versionControl/BackupControl.vue